import { IconProp } from '@fortawesome/fontawesome-svg-core';

const prefixByClass: Record<string, string> = {
  far: 'far',
  'fa-regular': 'far',
  fal: 'fal',
  'fa-light': 'fal',
};

export function toIconProp(icon?: string): IconProp | undefined {
  const trimmed = icon?.trim();
  if (!trimmed) return undefined;

  // Accept formats like:
  // - "fa-regular fa-circle" / "far fa-circle"
  // - "fa-solid fa-car" / "fas fa-car"
  // - "far:circle" / "fas:car"
  const colonIndex = trimmed.indexOf(':');
  if (colonIndex > 0 && colonIndex < trimmed.length - 1) {
    const prefix = trimmed.slice(0, colonIndex);
    const name = trimmed.slice(colonIndex + 1);
    return [prefix as any, name as any] as IconProp;
  }

  const parts = trimmed.split(/\s+/);
  // Prefer light over regular when multiple classes exist
  const prefix =
    parts.map((p) => prefixByClass[p]).find((p) => p === 'fal') ||
    parts.map((p) => prefixByClass[p]).find((p) => p === 'far');
  const faNameClass = parts.find((p) => p.startsWith('fa-') && !prefixByClass[p]);
  const name = faNameClass?.replace(/^fa-/, '');

  if (name && prefix) return [prefix as any, name as any] as IconProp;
  if (name) return name as any as IconProp;

  // Fallback: interpret as icon name (uses FontAwesome default prefix)
  return trimmed as any as IconProp;
}
